import script from "./PriceCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceCard.vue?vue&type=script&lang=ts&setup=true"

import "./PriceCard.vue?vue&type=style&index=0&id=1ce92d37&lang=scss"

const __exports__ = script;

export default __exports__